import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import $ from 'jquery'

// eslint-disable-next-line no-undef
const root = ReactDOM.createRoot(document.getElementById('root'))

$(document).ready(function() {
  if (window.location.pathname === "/listing") {
    setTimeout(() => {
      window.scrollTo({top: 0, behavior: 'instant'});
    }, 500);
  }

  $(document).on( "scroll", function() {
    let scrollTop = $(this).scrollTop();
    // Действия на возвращение пользователя
    if (scrollTop < 80) {
      $(".layout_header").removeClass('layout_header_active');
    } else {
      $(".layout_header").addClass('layout_header_active');
    }
  });
});


root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  // </React.StrictMode>
)
